import { render, staticRenderFns } from "./CreateBanner.vue?vue&type=template&id=f320f96c"
import script from "./CreateBanner.vue?vue&type=script&lang=js"
export * from "./CreateBanner.vue?vue&type=script&lang=js"
import style0 from "./CreateBanner.vue?vue&type=style&index=0&id=f320f96c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports